import { render, staticRenderFns } from "./RoleHelp.vue?vue&type=template&id=7a8b9957"
import script from "./RoleHelp.vue?vue&type=script&lang=js"
export * from "./RoleHelp.vue?vue&type=script&lang=js"
import style0 from "./RoleHelp.vue?vue&type=style&index=0&id=7a8b9957&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports